import { turboproApi } from '@/api/turbopro';
import type { DeletarAgendamentoPayload } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function deletarAgendamentoApi(payload: DeletarAgendamentoPayload): Promise<void> {
  await turboproApi<null>('Relatorios/DeletarAgendamento', {
    method: 'POST',
    body: payload,
    headers: getRelatoriosHeaders(),
  });
}
